import type { ScreenModule } from "../../../app/screen-module";
import { TenantCatalogPage } from "../pages";

export default {
	id: "tenant-admin.catalog",
	path: "/admin/catalog",
	area: "tenant-admin",
	navGroup: "利用できるもの",
	label: "Agent / UCS",
	roles: ["tenant_admin", "platform_admin"],
	backing: "MOCK_ONLY",
	enabled: true,
	component: TenantCatalogPage,
} satisfies ScreenModule;
